import { useCallback } from 'react';
import { prop } from 'ramda';
import { useAppSelector } from 'js/store/hooks';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useGetCurrencyRates = () => {
    const send = useGenericSend();
    const casino = useAppSelector(prop('casinoName'));

    return useCallback(async (request: Types.IGetCurrencyRatesRequestParams): Promise<Types.IGetCurrencyRatesResponseParams> => {
        const { data } = await send<Types.IGetCurrencyRatesRequestParams, Types.IGetCurrencyRatesResponseParams>({
            ID: 35922,
            responses: [35923, 35924],
            description: 'Get currency exchange rates',
            casino,
            ...request
        });

        return data;
    }, [send, casino]);
};
